import { render, staticRenderFns } from "./P5View.vue?vue&type=template&id=13cecb45&"
import script from "./P5View.vue?vue&type=script&lang=js&"
export * from "./P5View.vue?vue&type=script&lang=js&"
import style0 from "./P5View.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports